import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Select,
    MenuItem,
    TextField,
    FormControl,
    InputLabel,
    CircularProgress,
    InputAdornment, 
    IconButton 
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getDatosCuentaBancaria } from '../../actions/configuracion';
import { ICuentaBancaria } from './interface/iCuentaBancaria';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import colores from '../../shared/constants/styles';

const DialogSeleccionCuenta = () => {
    const dispatch = useDispatch();
    const datosCuentaBancaria = useSelector((state: any) => state.configuracion.datosCuentaBancaria);

    const [open, setOpen] = useState(false);
    const [cuentaBancarias, setCuentaBancarias] = useState<ICuentaBancaria[]>([]);
    const [selectedId, setSelectedId] = useState<number | string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const [copiedCbu, setCopiedCbu] = useState(false);
    const [copiedAlias, setCopiedAlias] = useState(false);


    const selectedCuenta = cuentaBancarias?.find((c) => c.id === selectedId);

    const handleOpen = () => {
        setOpen(true);
        setLoading(true);
        dispatch(getDatosCuentaBancaria());
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedId('');
    };

    const handleCopy = async (type: string) => {
        try {
            var copiedText="";
            if(type=== "cbu"){
                copiedText=selectedCuenta ? selectedCuenta.cbu: "";
                setCopiedCbu(true);
                setTimeout(() => setCopiedCbu(false), 1500); 
            } else {
                copiedText=selectedCuenta && selectedCuenta.alias? selectedCuenta.alias: "";
                setCopiedAlias(true);
                setTimeout(() => setCopiedAlias(false), 1500); 
            }
            await navigator.clipboard.writeText(copiedText);
        } catch (err) {
            console.error("Error al copiar", err);
        }
    };

    useEffect(() => {
        if (datosCuentaBancaria) {
            setCuentaBancarias(datosCuentaBancaria.$values || []);
            setLoading(false);
        }
    }, [datosCuentaBancaria]);

    const handleChange = (event: any) => {
        setSelectedId(event.target.value);
    };

    return (
        <>
            <Button 
                variant="contained" 
                style={{ backgroundColor: colores.rojo, color: '#fff' }}
                onClick={handleOpen}>
                VER CUENTA BANCARIAS
            </Button>

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Seleccionar cuenta bancaria</DialogTitle>
                <DialogContent dividers>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <>
                            <FormControl fullWidth margin="normal">
                                <InputLabel id="cuenta-label">Cuenta</InputLabel>
                                <Select
                                    labelId="cuenta-label"
                                    value={selectedId}
                                    onChange={handleChange}
                                    label="Cuenta"
                                >
                                    {cuentaBancarias.map((cuenta) => (
                                        <MenuItem key={cuenta.id} value={cuenta.id}>
                                            {cuenta.nombre}-{cuenta.sucursal}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {selectedCuenta && (
                                <> 
                                <TextField
                                    label="Nro. de Cuenta"
                                    value={selectedCuenta.nroCuenta}
                                    fullWidth
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    label="CBU"
                                    value={selectedCuenta.cbu}
                                    fullWidth
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={() => handleCopy("cbu")} edge="end" size="small">
                                                    <ContentCopyIcon fontSize="small" />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    helperText={copiedCbu ? "CBU copiado ✅" : ""}
                                />
                                <TextField
                                    label="Alias"
                                    value={selectedCuenta.alias}
                                    fullWidth
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={() => handleCopy("alias")} edge="end" size="small">
                                                    <ContentCopyIcon fontSize="small" />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    helperText={copiedAlias ? "Alias copiado ✅" : ""}
                                />
                                </>
                            )}
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DialogSeleccionCuenta;
